import { render, staticRenderFns } from "./ErrorLayout.vue?vue&type=template&id=71715b0a&scoped=true"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71715b0a",
  null
  
)

export default component.exports